import { Component, Input, OnInit, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { NGXLogger } from 'ngx-logger';
import { InterventiService } from '../../../services/interventi.service';
import { StoricoIntervento } from '../../../models/storico-intervento.model copy';
import { StiliService } from '../../../services/stili.service';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { Intervento } from '../../../models/intervento.model';

@Component({
  selector: 'app-storico-intervento',
  standalone: true,
  imports: [
    CommonModule,
    TimelineModule,
    CardModule,
    ButtonModule,
    TagModule,
    DividerModule,
    LottieComponent,
    DialogModule
  ],
  templateUrl: './storico.component.html',
  styleUrls: ['./storico.component.css']
})
export class StoricoInterventoComponent implements OnInit, OnChanges {
  @Input() interventoId!: number;
  @Input() intervento: Intervento | null = null;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  eventi: StoricoIntervento[] = [];
  isLoading: boolean = true;

  // Configurazione animazione Lottie
  lottieConfig: AnimationOptions = {
    path: 'assets/animations/spinner-storico-richiesta.json',
    autoplay: true,
    loop: true,
    renderer: 'svg'
  };
  animazione: any;

  constructor(
    private logger: NGXLogger,
    private interventiService: InterventiService,
    public stiliService: StiliService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['interventoId']) {
      if (this.interventoId && this.interventoId > 0) {
        console.log(`[STORICO] interventoId cambiato da ${changes['interventoId'].previousValue} a ${changes['interventoId'].currentValue}`);
        this.isLoading = true;
        this.caricaEventiStorico();
      }
    }
  }

  animationCreated(animation: any): void {
    this.animazione = animation;
    this.logger.info("[STORICO] Lottie animation created");
  }

  caricaEventiStorico(): void {
    console.log(`[STORICO] Caricamento eventi per l'intervento ${this.interventoId}`);
    this.isLoading = true;
    this.interventiService.getStoricoIntervento(this.interventoId).subscribe({
      next: (storicoIntervento: StoricoIntervento[]) => {
        this.eventi = storicoIntervento;
        this.logger.info(`[STORICO] Eventi storico caricati: ${this.eventi.length}`);
        this.isLoading = false;
      },
      error: (err) => {
        this.logger.error(`[STORICO] Errore nel caricamento eventi: ${err}`);
        this.isLoading = false;
      }
    });
  }

  getColorTag(tipo: string): 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'contrast' {
    switch(tipo) {
      case 'creazione': return 'info';
      case 'modifica': return 'warning';
      case 'finanziamento': return 'success';
      case 'rendicontazione': return 'secondary';
      default: return 'secondary';
    }
  }

  formatDate(date: Date): string {
    return date.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  show(intervento: any) {
    this.interventoId = intervento.id;
    this.intervento = intervento;
    this.visible = true;
    this.visibleChange.emit(true);
    this.caricaEventiStorico();
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.intervento = null;
    this.eventi = [];
    this.interventoId = 0;
  }
}
